// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sku-tab-content[data-v-4dd55a49]{background-color:#fafbfc!important;border:1px solid #e2e8f0;border-top:none!important}.border-bottom[data-v-4dd55a49]{border-bottom:1px solid #edf2f7}.gap-2[data-v-4dd55a49]{gap:8px}", ""]);
// Exports
module.exports = exports;
